import React from "react";
import { Search, ChevronUp, ChevronDown } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";
import { Card } from "@/components/ui/card";

export default function FiltersSidebar() {
  return (
    <Card className="p-0 bg-white rounded-xl shadow-none border-none overflow-hidden">
      
      {/* Header */}
      <div className="p-4 border-b">
        <h3 className="font-bold text-gray-800">All Filters</h3>
      </div>

      {/* Company Type */}
      <div className="p-4 border-b">
        <div className="flex justify-between items-center mb-4 cursor-pointer">
          <h4 className="text-sm font-semibold text-gray-800">Company type</h4>
          <ChevronUp className="w-4 h-4 text-gray-500" />
        </div>

        <div className="space-y-3">
          {[
            { label: "Corporate", count: 4603 },
            { label: "Foreign MNC", count: 1530 },
            { label: "Startup", count: 745 },
            { label: "Indian MNC", count: 624 },
          ].map((item, idx) => (
            <div key={idx} className="flex items-center gap-2">
              <Checkbox
                id={`type-${idx}`}
                className="border-gray-300 data-[state=checked]:bg-[#2557a7]"
              />
              <Label
                htmlFor={`type-${idx}`}
                className="text-sm text-gray-600 flex-1 cursor-pointer"
              >
                {item.label}{" "}
                <span className="text-gray-400 text-xs">({item.count})</span>
              </Label>
            </div>
          ))}
        </div>
      </div>

      {/* Location */}
      <div className="p-4 border-b">
        <div className="flex justify-between items-center mb-4 cursor-pointer">
          <h4 className="text-sm font-semibold text-gray-800">Location</h4>
          <ChevronUp className="w-4 h-4 text-gray-500" />
        </div>

        <div className="relative mb-3">
          <Input
            placeholder="Search Location"
            className="pl-9 h-9 text-sm bg-gray-50 border-gray-200"
          />
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-3.5 h-3.5 text-gray-400" />
        </div>

        <div className="space-y-3">
          {[
            { label: "Bangalore/Bengaluru", count: 2100 },
            { label: "Delhi / NCR", count: 1840 },
            { label: "Mumbai", count: 1560 },
            { label: "Pune", count: 980 },
          ].map((item, idx) => (
            <div key={idx} className="flex items-center gap-2">
              <Checkbox
                id={`loc-${idx}`}
                className="border-gray-300 data-[state=checked]:bg-[#2557a7]"
              />
              <Label
                htmlFor={`loc-${idx}`}
                className="text-sm text-gray-600 flex-1 cursor-pointer"
              >
                {item.label}{" "}
                <span className="text-gray-400 text-xs">({item.count})</span>
              </Label>
            </div>
          ))}
        </div>
      </div>

      {/* Industry */}
      <div className="p-4 border-b">
        <div className="flex justify-between items-center mb-4 cursor-pointer">
          <h4 className="text-sm font-semibold text-gray-800">Industry</h4>
          <ChevronDown className="w-4 h-4 text-gray-500" />
        </div>
      </div>

      {/* Department */}
      <div className="p-4">
        <div className="flex justify-between items-center mb-4 cursor-pointer">
          <h4 className="text-sm font-semibold text-gray-800">Department</h4>
          <ChevronDown className="w-4 h-4 text-gray-500" />
        </div>
      </div>
    </Card>
  );
}
